import React, { useMemo, useState } from 'react';
import DHeader from '../../pieces/DHeader';
import DText from '../../pieces/DText';
import DCode from '../../pieces/DCode';

export default function WorkflowNode() {

    return (
        <div>
            <DHeader>Nodes</DHeader>
       
            <DText>
            Nodes serve as the core building blocks in workflows in Laeyerz. The functions to be computed, which we call Actions, are built into the Nodes. When a workflow is executed, the Node is what is called by the orchestrator. 
            </DText>

            <DText>
                Nodes and Actions have been kept separated because Nodes with multiple Actions simplify the configuration and management of the connectors. For example, a Vector store connector can have a Store and a Search Action in the same Node. 
            </DText>

            <DText>
            Let us start with the simplest way of creating a single-Action Node.

Continuing with our two-step example, let us convert the functions into Nodes.
            </DText>
            
            <DCode>
                {`from laeyerz.flow.Node import Node

node0 = Node("Model0")
node0_inputs = [
    {
        "name":"input0",
        "type":"str",
        "description":"Input to the model",
        "inputType":"source",
        "source":"INPUTS|input0",
        "value":None
    }
]
node0_outputs = [
    {
        "name":"output0",
        "type":"str",
        "description":"Output from the model"
    }
]
node0.set_function("model0",model0, params, node0_inputs, node0_outputs)`}
            </DCode>

            <DText>Similarly we can create a Node for the second function.</DText>

            <DCode>
              {`node1 = Node("Model1")
node1_inputs = [
    {
        "name":"input1",
        "type":"str",
        "description":"Input to the model",
        "inputType":"source",
        "source":"Model0|model0|output0",
        "value":None
    }
]
node1_outputs = [
    {
        "name":"output1",
        "type":"str",
        "description":"Output from the model"
    }
]
node1.set_function("model1",model1, params, node1_inputs, node1_outputs)
`}

            </DCode>

            <DText>
            For more complex use cases, you can create custom Nodes that have multiple actions, config and even State, if required. 
            
            </DText>
            {/* To learn more about that check out the Custom Node section. */}
       
        </div>
    )
}